import React from 'react';
import styles from './table-of-contents.module.scss';
import { withErrorBoundary } from '@buzzfeed/react-components';
import { captureException } from '@sentry/nextjs';
import { useTranslation } from '../../i18n';


function TableOfContents({ buzz = {} }) {
  const { t } = useTranslation('common');
  const tableOfContents = buzz.table_of_contents;
  const label = 'table-of-contents';

  if (!tableOfContents || typeof tableOfContents !== 'object' || !Array.isArray(tableOfContents) || tableOfContents.length < 2) {
    return null;
  }
  const isUsShopping = !!buzz.isShopping && buzz.country_code === 'en-us';

  return (
    <section className={`${isUsShopping ? styles.usShoppingTableOfContents : styles.tableOfContents}`} aria-labelledby={label}>
      <div className={styles.contentWrapper}>
        <h2 id={label} className={`${buzz.isShopping ? styles.shoppingTitle : styles.title}`}>
          {t('table_of_contents')}
        </h2>
        <ul className={styles.tocList}>
          {tableOfContents.map((item) => (
            item.title ? (
              <li key={item.id} className={styles.tocItem}>
                <a
                  href={`#${item.id}`}
                  className={styles.tocLink}
                  dangerouslySetInnerHTML={{ __html: item.title }}
                />
              </li>
              ) : null
          ))}
        </ul>
      </div>
    </section>
  );
}

export default withErrorBoundary(TableOfContents, {
  onError: captureException,
});
